define(['vendor/material.min.js'], function(mdl) {
  /*var TextCard = function () {
    var el = document.getElementById("test_me");
    var chEl = el.children;
    var sumHeight = 0;

    for(var i = 0; i < chEl.length; i++) {
      var item = chEl[i], itemStl;

      if(item.nodeType === Node.ELEMENT_NODE) {
        sumHeight += item.offsetHeight + sumParams(item, paramsToSumm);
      }
    }
  };

  TextCard.prototype._paramsToSumm = ['paddingTop', 'paddingBottom', 'marginTop', 'marginBottom'];

  TextCard.prototype.init = function () {

  };

  TextCard.prototype.sumParams = function (el, params) {
    var itemStl = el.currentStyle || window.getComputedStyle(el)
      ,sum = 0;

    if(itemStl && params.length) {
      for(var i = 0; i < params.length; i++) {
        sum += (parseFloat(itemStl[params[i]]) || 0).toFixed(2) * 1;
      }
    }

    return sum;
  };

  return TextCard;
  */

  var CaTextCard = function CaTextCard(element) {
    this.element_ = element;
    this.setDefaults_();

    // Initialize instance.
    this.init();
  };
  window['CaTextCard'] = CaTextCard;

  CaTextCard.prototype.CssClasses_ = {
    OVERLAY_BOX: 'ca-card--overlay-box',
    TOGGLE_BTN: 'ca-card--toggle-btn',
    IS_UPGRADED: 'is-upgraded',
    IS_ANIMATED: 'is-animated'
  };

  CaTextCard.prototype.setDefaults_ = function () {
    this.initHeight_ = 0;
    this.paddindByHeight_ = 0;
    this.contentHeight_ = 0;
    this.isExpanded_ = false;
    this.overlayBox_ = null;
    this.expandBtn_ = null;
  };

  CaTextCard.prototype.paramsToSummForChildren_ = [ 'paddingTop', 'paddingBottom', 'marginTop', 'marginBottom' ];
  CaTextCard.prototype.paramsToSumm_ = [ 'paddingTop', 'paddingBottom' ];

  CaTextCard.prototype.sumParams_ = function (el, params) {
    var itemStl = el.currentStyle || window.getComputedStyle(el)
      ,sum = 0;

    if(itemStl && params.length) {
      for(var i = 0; i < params.length; i++) {
        sum += (parseFloat(itemStl[params[i]]) || 0).toFixed(2) * 1;
      }
    }

    return sum;
  };

  CaTextCard.prototype.onClick_ = function (event) {
    if(this.isExpanded_) {
      this.element_.style.maxHeight = this.element_.style.height = this.initHeight_ + 'px';
    }
    else {
      this.element_.style.maxHeight = this.element_.style.height = this.contentHeight_ + this.paddindByHeight_/2 + this.overlayBox_.offsetHeight + 'px';
    }

    this.isExpanded_ = !this.isExpanded_;
  };

  /**
   * Initialize element.
   */
  CaTextCard.prototype.init = function() {
    if (this.element_) {
      this.initHeight_ = this.element_.offsetHeight;
      this.paddindByHeight_ = this.sumParams_(this.element_, this.paramsToSumm_);

      var chEl = this.element_.children
        ,sumHeight = 0;

      for(var i = 0; i < chEl.length; i++) {
        var item = chEl[i];

        if(item.nodeType === Node.ELEMENT_NODE) {
          sumHeight += item.offsetHeight + this.sumParams_(item, this.paramsToSummForChildren_);
        }
      }

      this.contentHeight_ = sumHeight;

      if(this.contentHeight_ > this.initHeight_) {
        this.boundClickHandler = this.onClick_.bind(this);
        var icon = document.createElement("i");
        icon.classList.add('fa');
        icon.classList.add('fa-ellipsis-h');
        var overlayBox = document.createElement("div");
        overlayBox.classList.add(this.CssClasses_.OVERLAY_BOX);
        var expandBtn = this.expandBtn_ = document.createElement("div");
        expandBtn.classList.add(this.CssClasses_.TOGGLE_BTN);
        expandBtn.addEventListener('click', this.boundClickHandler);
        expandBtn.appendChild(icon);
        overlayBox.appendChild(expandBtn);
        this.element_.appendChild(overlayBox);
        this.overlayBox_ = overlayBox;
      }

      this.boundmdlDowngrade_ = this.mdlDowngrade_.bind(this);
      this.element_.addEventListener('mdl-componentdowngraded', this.boundmdlDowngrade_);
      this.element_.classList.add(this.CssClasses_.IS_ANIMATED);
      this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
    }
  };

  CaTextCard.prototype.mdlDowngrade_ = function () {
    if(this.expandBtn_) {
      this.expandBtn_.removeEventListener('click', this.boundClickHandler);
      this.boundClickHandler = null;
      this.expandBtn_.removeEventListener('mdl-componentdowngraded', this.boundmdlDowngrade_);
      this.boundmdlDowngrade_ = null;
    }

    this.overlayBox_ && this.element_.removeChild(this.overlayBox_);
    this.overlayBox_ = null;
    this.element_.classList.remove(this.CssClasses_.IS_UPGRADED);
  };

  componentHandler.register({
    constructor: CaTextCard,
    classAsString: 'CaTextCard',
    cssClass: 'ca-js-card',
    widget: true
  });

  /********* Modal Text Card **********/

  var CaTextCardModal = function CaTextCardModal(element) {
    this.element_ = element;
    this.setDefaults_();

    // Initialize instance.
    this.init();
  };
  window['CaTextCardModal'] = CaTextCardModal;

  CaTextCardModal.prototype.CssClasses_ = {
    OVERLAY_BOX: 'ca-card--overlay-box',
    OVERLAY_BOX_STYLE: 'ca-card--overlay-box--small',
    IS_UPGRADED: 'is-upgraded',
    IS_ANIMATED: 'is-animated'
  };

  CaTextCardModal.prototype.setDefaults_ = function () {
    this.initHeight_ = 0;
    this.paddindByHeight_ = 0;
    this.contentHeight_ = 0;
    this.isExpanded_ = false;
    this.overlayBox_ = null;
    this.expandBtn_ = null;
  };

  CaTextCardModal.prototype.onClick_ = function (event) {
  };

  CaTextCardModal.prototype.init = function() {
    if (this.element_) {
      this.boundClickHandler = this.onClick_.bind(this);
      var overlayBox = document.createElement("div");
      overlayBox.classList.add(this.CssClasses_.OVERLAY_BOX);
      overlayBox.classList.add(this.CssClasses_.OVERLAY_BOX_STYLE);
      this.element_.appendChild(overlayBox);
      this.overlayBox_ = overlayBox;

      this.boundmdlDowngrade_ = this.mdlDowngrade_.bind(this);
      this.element_.addEventListener('mdl-componentdowngraded', this.boundmdlDowngrade_);
      this.element_.classList.add(this.CssClasses_.IS_ANIMATED);
      this.element_.classList.add(this.CssClasses_.IS_UPGRADED);
    }
  };

  CaTextCardModal.prototype.mdlDowngrade_ = function () {
    if(this.expandBtn_) {
      this.expandBtn_.removeEventListener('click', this.boundClickHandler);
      this.boundClickHandler = null;
      this.expandBtn_.removeEventListener('mdl-componentdowngraded', this.boundmdlDowngrade_);
      this.boundmdlDowngrade_ = null;
    }

    this.overlayBox_ && this.element_.removeChild(this.overlayBox_);
    this.overlayBox_ = null;
    this.element_.classList.remove(this.CssClasses_.IS_UPGRADED);
  };

  componentHandler.register({
    constructor: CaTextCardModal,
    classAsString: 'CaTextCardModal',
    cssClass: 'ca-js-card-modal',
    widget: true
  });
});